<!--
 * @Description: 经办人信息核验成功组件
 * @Version: 1.0
 * Autor: zhangle
 * @Date: 2026-05-21
 * @LastEditors: zhangle
 * @LastEditTime: 2026-05-21
-->
<template>
    <div class="tsa-handlerVerifySuccess" v-show="show">
        <div class="mask"></div>
        <div class="content">
            <div class="title-top">
                <h4>提示</h4>
            </div>
            <div class="scroll">
                <p>您将以经办人身份为企业申请数字证书。</p>
                <p>如实填报：确保所提交的企业及个人身份信息真实、有效；</p>
                <p>配合核验：完成实名认证</p>
                <p>责任承担：对因提供虚假信息导致的法律后果承担相应责任；</p>
                <p>信息采集：授权北京联合信任技术服务有限公司及CSCA依法收集和保存电子认证相关信息，包括但不限于姓名、证件号码、证件照片、手机号、银行卡号、人脸照片、生物特征信息、证书申请意愿记录等信息，信息保存期限至少为电子签名认证证书失效后五年；</p>
                <p>信息使用：手机号、邮箱等信息可用于账号绑定、接收通知和签名校验信息。</p>
            </div>
            <div class="bottom">
                <div class="btn cancel" @click="close">
                    <p>取消</p>
                </div>
                <div class="btn confirm" @click="confirm">
                    <p>确认</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { setBodyOverflow } from '@/js/utils'
export default {
    name: 'TsaHandlerVerifySuccess',
    data () {
        return {
            show: false
        }
    },
    watch: {
        show (val) {
            setBodyOverflow(val)
        }
    },
    methods: {
        close () {
            this.show = false
        },
        confirm () {
            this.show = false
            this.onConfirm && this.onConfirm()
        }
    }
}
</script>

<style lang="less" scoped>
    .tsa-handlerVerifySuccess {
        position: fixed;
        z-index: 9;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        * {
            box-sizing: border-box;
        }
        .mask {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.65);
        }
        .content {
            display: flex;
            flex-direction: column;
            position: absolute;
            top: 50%;;
            left: 50%;
            width: 85%;
            transform: translate(-50%, -50%);
            border-radius: 8px;
            background: #FFFFFF;
            .title-top {
                flex-shrink: 0;
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-bottom: 16px;
                padding: 16px 20px 0 16px;
                h4 {
                    font-weight: bold;
                    font-size: 18px;
                    color: #000000;
                }
            }
            .scroll {
                flex: 1;
                overflow-y: auto;
                -webkit-overflow-scrolling: touch;
                padding: 0 16px;
                p {
                    font-size: 14px;
                    color: #666666;
                }
            }
            .bottom {
                flex-shrink: 0;
                width: 100%;
                display: flex;
                padding: 24px;
                justify-content: center;
                .btn {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 156px;
                    height: 44px;
                    border-radius: 8px;
                    border: 1px solid #D9D9D9;
                    p {
                        font-weight: bold;
                        font-size: 14px;
                        color: #000000;
                    }
                }
                .cancel {
                    margin-right: 10px;
                }
                .confirm {
                    background: linear-gradient( 90deg, #0047FF 0%, #2377FF 100%);
                    p {
                        color: #FFFFFF;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/handlerVerifySuccess/index.vue